module.exports = __webpack_public_path__ + "img/security-card.1ced957e.svg";